import { PageDataError } from 'src/shared/error';

import type { HomepageTopImpactStoriesDataQuery } from '../homepageTopImpactStories.graphql';

export type HomepagePageDataErrorCode = 'homepage_page_data_not_found';

export class HomepagePageDataError extends PageDataError<HomepagePageDataErrorCode> {}

export type TopImpactStoryPetitionData = {
	id: NonNullable<HomepageTopImpactStoriesDataQuery['petition']>['id'];
	slug: NonNullable<HomepageTopImpactStoriesDataQuery['petition']>['slug'];
	signatureCount: string;
	isVictory: boolean;
};

export type ImpactStoryFCMData = {
	summary: string;
	imageUrl: string;
	badgeTitle: string;
	testimonialUrl: string;
};
